module.exports = new __parcel__URL__("pattern.3023fd2d.glb").toString();